import React, { useId } from "react";
import { cn } from "@/helpers/utils";
import { SvgIcon, SvgIconProps } from "@mui/material";

const PlusMinusIcon = ({
  expanded,
  ...props
}: SvgIconProps & { expanded: boolean }) => {
  const lineId = useId();
  return (
    <div className="flex items-center">
      <SvgIcon
        className={`plusMinusIcon stroke-gray-700`}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        {...props}
      >
        <line
          id={lineId}
          x1="4"
          x2="16"
          y1="10"
          y2="10"
          height={2}
          strokeWidth={2}
          strokeLinecap={"round"}
        />
        <use
          xlinkHref={`#${lineId}`}
          className={cn("transition", expanded ? "rotate-180" : "rotate-90")}
          transform-origin="10px 10px"
        />
      </SvgIcon>
    </div>
  );
};

export default PlusMinusIcon;
